import { Injectable } from "@angular/core";
import { Headers, Http, RequestOptions, Response } from "@angular/http";
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from "@angular/router";
import { LocationStrategy } from '@angular/common';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/observable/throw';

import { User } from "../_models/index";

@Injectable()
export class UserService {
    constructor(private http: Http, private router: Router, private _route: ActivatedRoute, private url: LocationStrategy
    ) {
    }

    errorHandler(e) {

        this.router.navigate(['/login']);
        return false;

    }


    checkParentAppAthlete(token: string, athlete_id: string) {

        console.log("checkParentAppAthlete");
        let headers = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        let options = new RequestOptions({ headers: headers });

        var body = 'token=' + token + '&athlete_id=' + athlete_id;
        return this.http.post(environment.apiUrl + 'check_parent_app_athlete', body, options).map((response: Response) => {
            let user = response.json();
            user = user.data;
            console.log(user);
            if (user && user.access_token) {
                user.role = user.userdata.role_slug;
                if (user.userdata.is_parent_user_account) {
                    user.role = "parent_primary";
                }
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));

                if (user.userdata.athletes && user.userdata.athletes[0]) { //get association and club info
                    //var athleteObj = user.userdata.athletes[0];

                    var filteredAthleteArray = user.userdata.athletes.filter(function(el) {
                        return el.athlete_id == user.athlete_id;
                    });

                    console.log(filteredAthleteArray);
                    var athleteObj = filteredAthleteArray[0];

                    var associationObj: any = {};
                    associationObj.association_id = athleteObj.association_id;
                    associationObj.association_name = athleteObj.association_name;
                    associationObj.association_subtitle = athleteObj.association_subtitle;
                    associationObj.association_logo = athleteObj.association_logo;

                    console.log(associationObj);

                    var clubObj: any = {};
                    clubObj.club_id = athleteObj.club_id;
                    clubObj.club_website = athleteObj.club_website;

                    var teamObj: any = {};
                    teamObj.team_id = athleteObj.team_id;

                    localStorage.setItem('sg_association_data', JSON.stringify(associationObj));
                    localStorage.setItem('sg_club_data', JSON.stringify(clubObj));
                    localStorage.setItem('sg_team_data', JSON.stringify(teamObj));
                    localStorage.setItem('is_parent_app_webview', 'true');

                    this.router.navigate(['/parent/dashboard/' + user.athlete_id]);

                }


                return true;
            } else {
                this.router.navigate(['/non-club-athlete']);
                return false;
            }


        });
    }


    verify() {
        return this.http.get(environment.apiUrl + 'oauth/verify', this.jwt())
            .map((response: Response) => response.json())
            .catch((e: any) => Observable.throw(this.errorHandler(e)));
    }

    checkToken(token: string) {
        return this.http.post(environment.apiUrl + 'check_token/' + token, this.jwt())
            .map((response: Response) => response.json())
            .catch((e: any) => Observable.throw(this.errorHandler(e)));
    }

    forgotPassword(email: string) {
        let headers = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        let options = new RequestOptions({ headers: headers });

        var body = 'email=' + email;
        return this.http.post(environment.apiUrl + 'forgotpassword', body, options).map((response: Response) => response.json());
    }

    getAll() {
        return this.http.get('/api/users', this.jwt()).map((response: Response) => response.json());
    }

    getById(id: number) {
        return this.http.get('/api/users/' + id, this.jwt()).map((response: Response) => response.json());
    }

    create(user: User) {
        return this.http.post('/api/users', user, this.jwt()).map((response: Response) => response.json());
    }

    update(user: User) {
        return this.http.put('/api/users/' + user.id, user, this.jwt()).map((response: Response) => response.json());
    }

    delete(id: number) {
        return this.http.delete('/api/users/' + id, this.jwt()).map((response: Response) => response.json());
    }

    getClubTeams(id: number) {
        return this.http.get(environment.apiUrl + 'club/' + id + '/teams', this.jwt()).map((response: Response) => response.json());
    }



    // private helper methods

    private jwt() {
        // create authorization header with jwt token
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log(currentUser);
        if (currentUser && currentUser.access_token) {
            console.log("has token");
            //let headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.access_token });
            let headers = new Headers({ 'access_token': currentUser.access_token });
            return new RequestOptions({ headers: headers });
        } else {
            console.log(this.url);
            /*
            if (this.url._platformLocation.pathname != "/login") {
                this.router.navigate(['/login']);
            }
            */
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/_services/user.service.ts